import type { WidgetVersion } from "../../constants/widget-assets";
import { getWidgetAssetUrls } from "../../constants/widget-assets";

export function generateWidgetEmbedScript(args: {
  widgetVersion?: WidgetVersion;
  widgetId?: string | null;
  inlineConfig?: unknown;
}): string {
  const { widgetVersion = "1", widgetId, inlineConfig } = args;
  const urls = getWidgetAssetUrls(widgetVersion);

  if (widgetId) {
    return `<!-- Notifyy WhatsApp Widget -->
<script src="${urls.js}"
  data-widget-id="${widgetId}"
  async>
</script>
<!-- End Notifyy Widget -->`;
  }

  const configString = JSON.stringify(inlineConfig ?? {}, null, 2);
  return `<!-- Notifyy WhatsApp Widget -->
<script>
  window.NotifyyWidgetConfig = ${configString};
</script>
<link rel="stylesheet" href="${urls.css}">
<script src="${urls.js}" async></script>
<!-- End Notifyy Widget -->`;
}

